import React from 'react';
import { TShieldVisualName, VisualShield } from './visual/VisualShield';
import { TShieldTextName, TextShieldV2 } from './text/TextShield';
import { TShieldCombinedName, CombinedShield } from './combined/CombinedShield';

export interface IAbstractDishShield {
    type: 'combined' | 'text' | 'visual' | 'upper' | 'upperText' | 'textSpecial',
    name: TShieldVisualName & TShieldTextName & TShieldCombinedName
}

export const AbstractDishShieldV2 = React.memo((props: IAbstractDishShield) => {
    const { type, name } = props;

    return (
        <>
            {type === 'combined' && <CombinedShield name={name} />}
            {type === 'text' && <TextShieldV2 name={name} />}
            {type === 'visual' && <VisualShield name={name} />}
        </>
    );
});
